import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')
const Transformation = () => import('../views/Transformation')
const About = () => import('../views/About')


const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: '/',
      component: HomePage
    },
    {
      path: '/transformation',
      component: Transformation
    },
    {
      path: '/about',
      component: About
    }
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js